<template>
  <!-- Envio do registro da atividade pelo próprio voluntário: fotos e depoimento.
       O conteúdo entra pendente e só aparece na landing page depois que o gestor
       aprova, então o texto do rodapé avisa isso -- sem esse aviso a pessoa envia e
       fica esperando ver o depoimento publicado na hora. -->
  <Modal
    v-model="dialog"
    modalTitle="Registre o seu voluntariado"
    :cardTitle="true"
    :withClose="true"
    myMaxWidth="640px"
    @input="close"
  >
    <v-container fluid pa-0>
      <v-layout column pa-0>
        <v-flex sm12 v-if="offer">
          <div class="f-size-14 text-dark mb-3">
            <strong>{{ offer.offerName }}</strong>
          </div>

          <v-textarea
            v-model="testimony"
            label="Como foi a sua experiência?"
            rows="5"
            counter="2000"
            maxlength="2000"
            :error-messages="testimonyError"
            @input="testimonyError = null"
          ></v-textarea>

          <div class="f-size-14 text-dark mt-2 mb-2">
            Fotos <span class="f-size-12">(até {{ maxFiles }}, JPG ou PNG)</span>
          </div>

          <div class="layout gap-sm align-center wrap">
            <div
              v-for="(item, index) in files"
              :key="'photo-' + index"
              class="upload-image square"
              style="position: relative"
            >
              <img :src="item.file.path" style="width: 100%; height: 100%; object-fit: cover" />
              <button
                class="fal fa-times-circle text-orange f-size-18"
                style="position: absolute; top: 2px; right: 2px; background: #fff; border-radius: 50%"
                @click="removeFile(index)"
              ></button>
            </div>

            <label
              v-if="files.length < maxFiles"
              for="upload-user-testimony"
              class="upload-image square layout column align-center justify-center"
              style="cursor: pointer"
            >
              <i class="fal fa-cloud-upload f-size-20"></i>
              <span class="f-size-12">Foto</span>
            </label>
            <input
              id="upload-user-testimony"
              type="file"
              accept="image/png, image/jpeg"
              style="display: none"
              ref="uploadUserTestimony"
              @change="fileChanged"
            />
          </div>

          <div v-if="filesError" class="text-orange f-size-12 mt-2">{{ filesError }}</div>

          <div class="f-size-12 text-dark mt-4">
            O seu depoimento passa por uma revisão da instituição antes de aparecer na
            página do voluntariado.
          </div>

          <div class="layout gap-xs mt-4 justify-end">
            <v-btn outline @click="close">Cancelar</v-btn>
            <v-btn class="btn-primary ma-0" :disabled="saving" @click="save">Enviar</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script type="plain/text">
import Modal from "@/components/Modal.vue";
import VolunteeringService from "@/scripts/services/volunteering.service";
import CommonHelper from "@/scripts/helpers/common.helper";

export default {
  components: {
    Modal,
  },
  props: {
    value: Boolean,
    // Inscrição a que o registro se refere. Traz registrationOfferId e offerName.
    offer: Object,
  },
  data() {
    return {
      volunteeringService: new VolunteeringService(),
      dialog: false,
      testimony: "",
      // Mesmo teto do back-end (MaxFilesPerTestimony): a foto sobe em base64 no corpo
      // da request, e sem limite o payload estoura.
      maxFiles: 5,
      files: [],
      testimonyError: null,
      filesError: null,
      saving: false,
    };
  },
  watch: {
    value() {
      this.dialog = this.value;
      if (this.value) this.reset();
    },
  },
  methods: {
    reset() {
      this.testimony = "";
      this.files = [];
      this.testimonyError = null;
      this.filesError = null;
      this.saving = false;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    fileChanged(event) {
      const selected = event.target.files[0];
      if (!selected) return;

      // Mesmo caminho do upload de depoimento do passo 2: a imagem vai como data URL
      // e o back-end faz o upload de verdade ao salvar.
      const reader = new FileReader();
      reader.onload = () => {
        this.files.push({
          fileId: 0,
          file: {
            name: selected.name,
            path: reader.result,
            size: selected.size,
            extension: selected.name.split(".").pop(),
          },
        });
        this.filesError = null;
      };
      reader.readAsDataURL(selected);

      // Limpa o input para que escolher o mesmo arquivo de novo dispare o change.
      event.target.value = "";
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    async save() {
      if (!this.testimony || !this.testimony.trim()) {
        this.testimonyError = "Escreva o seu depoimento sobre a experiência.";
        return;
      }

      if (!this.files.length) {
        this.filesError = "Envie ao menos uma foto do seu voluntariado.";
        return;
      }

      this.saving = true;

      const result = await this.volunteeringService.saveUserTestimony({
        volunteeringRegistrationOfferId: this.offer.registrationOfferId,
        testimony: this.testimony.trim(),
        files: this.files,
      });

      this.saving = false;

      // O erro já foi mostrado pelo handleError do serviço; sem resultado, mantém o
      // modal aberto com o que a pessoa escreveu, para ela não perder o texto.
      if (!result) return;

      CommonHelper.swal(
        "Enviado",
        "Obrigado! O seu registro foi enviado para a instituição.",
        "success"
      );
      this.$emit("saved");
      this.close();
    },
  },
};
</script>
